import { t } from 'i18next';
import { CellProps } from 'react-table';

import { CellText } from 'coreOld/elements';
import { AlignText } from 'coreOld/enums';
import { USER_STATUSES_LABEL } from 'system/constants';
import { UserStatusLabel } from 'system/enums';
import { ISystemUser } from 'system/types';

import UserSetting from '../UserSetting';

const getUserStatus = (user: ISystemUser) => {
  if (user.blocked) {
    return UserStatusLabel.BLOCKED;
  }

  return USER_STATUSES_LABEL[user.status];
};

export const columns = [
  {
    Header: 'User',
    accessor: 'name',
    Cell: ({ row }: CellProps<ISystemUser, any>) => (
      <CellText mainText={row.original.name} linkText={row.original.email} />
    ),
  },
  {
    Header: 'Rank',
    accessor: 'ranks',
  },
  {
    Header: () => <CellText mainText={t('labelCompany')} subTexts={[t('labelAssignedCompany')]} />,
    accessor: 'companyName',
    Cell: ({ row }: CellProps<ISystemUser, any>) => (
      <CellText
        mainText={
          row.original.companyId ? `${row.original.companyName} [${row.original.companyId}]` : ''
        }
        subTexts={
          row.original.assignedCompanyId
            ? [`${row.original.assignedCompanyName} [${row.original.assignedCompanyId}]`]
            : []
        }
      />
    ),
  },
  {
    Header: 'Status',
    accessor: 'status',
    Cell: ({ row }: CellProps<ISystemUser, any>) => (
      <CellText mainText={getUserStatus(row.original)} />
    ),
    flex: 50,
  },
  {
    accessor: 'createdAt',
    Header: () => <CellText alignText={AlignText.RIGHT} mainText="Created" />,
    Cell: ({ row }: CellProps<ISystemUser, any>) => (
      <CellText
        alignText={AlignText.RIGHT}
        mainText={row.original.createdAt}
        subTexts={[row.original.userIp]}
      />
    ),
  },
  {
    accessor: 'userId',
    Header: () => <CellText alignText={AlignText.RIGHT} mainText="User ID" />,
    Cell: ({ row }: CellProps<ISystemUser, any>) => (
      <CellText alignText={AlignText.RIGHT} mainText={row.original.userId} />
    ),
    flex: 100,
  },
  {
    accessor: 'allowQuoteReleaseWithoutSendingEmail',
    Header: () => (
      <CellText mainText="Allow Quote Release Without Sending Email" alignText={AlignText.CENTER} />
    ),
    Cell: ({ row }: CellProps<ISystemUser, any>) => <UserSetting user={row.original} />,
    flex: 100,
  },
];
